import React, { useState, useContext, createContext, useEffect } from "react";
import useConnectWallet from "./hook/useConnectWallet";
import useTrackEvent from "./hook/useTrackEvent";
import { useSearchParams } from "react-router-dom";
import { apiUrl } from "features/configure";

// Create Context
const OnboardingContext = createContext();

export const useOnboardingState = () => useContext(OnboardingContext);

export const OnboardingContextProvider = ({ children }) => {
  const [step, setStep] = useState(-1);
  const [ecosystem, setEcosystem] = useState(null); // null , "EVM" , "Solana"
  const [email, setEmail] = useState("");
  // compare wallet or email by type
  const [type, setType] = useState("");

  const [params, setParams] = useSearchParams();

  const {
    connectorList,
    handleConnectWallet,
    handleDisconnectWallet,
    walletType,
    address,
    isConnected,
    isConnecting,
  } = useConnectWallet({ ecosystem });

  useEffect(() => {
    // for switch workspace (i don't want user to switch step by url, so only have step 1 condition)
    if (params.get("step") === "1") {
      if (!address) return setStep(-1);
      setStep(1);
    }
  }, [params]);

  useEffect(() => {
    if (step < -1 || step > 3) setStep(-1);
  }, [step]);

  function nextStep() {
    setStep((prevStep) => prevStep + 1);
    setParams({});
  }

  function prevStep() {
    setStep((prevStep) => prevStep - 1);
    setParams({});
  }

  function chooseEcoSystem(system) {
    setStep(0);
    setEcosystem(system);
  }

  const trackEvent = useTrackEvent();

  useEffect(() => {
    if (!ecosystem) return;
    if (address && isConnected && walletType) {
      trackEvent("onboarding_wallet_connected", {
        wallet_type: walletType,
      });
      setStep(1);
    }
  }, [ecosystem, address, isConnected, isConnecting, walletType]);

  async function connectWallet(data) {
    await handleConnectWallet(data);
    setType("wallet");
    trackEvent("onboarding_wallet_connected", {
      wallet_type: walletType,
    });
    // setStep(1);
  }

  function connectGoogle() {
    // 開啟一個小視窗
    const authWindow = window.open(
      `${apiUrl}/api/auth/google`, // 後端 Google OAuth 登入 URL
      "_blank",
      "width=500,height=600"
    );

    // 監聽後端回傳的 email
    const handleMessage = (event) => {
      if (event.origin !== apiUrl) return; // 確保是從後端來的
      const email = event.data?.email;
      if (email) {
        authWindow.close(); // 關閉小視窗
        setEmail(email);
        setType("email");
        setStep(1);
      }
      window.removeEventListener("message", handleMessage);
    };

    window.addEventListener("message", handleMessage);
  }

  async function disconnect() {
    try {
      await handleDisconnectWallet();
      trackEvent("onboarding_wallet_disconnected");
      if (ecosystem === null) {
        setStep(-1);
      } else {
        setStep(0);
      }
      setType("");
      setEmail("");
    } catch (error) {
      trackEvent("onboarding_wallet_disconnect_error", {
        error_message: error.message,
      });
    }
  }

  return (
    <>
      <OnboardingContext.Provider
        value={{
          step,
          setStep,
          nextStep,
          prevStep,
          ecosystem,
          chooseEcoSystem,
          // compare wallet or email by type
          type,

          // for email
          email,
          connectGoogle,

          // for connect wallet
          connectorList,
          connectWallet,
          disconnect,
          address,
          isConnected,
          isConnecting,
        }}
      >
        {children}
      </OnboardingContext.Provider>
    </>
  );
};

export default OnboardingContextProvider;
